import styles from 'containers/calculator/styles/components/slider.module.css'

export const Slider = ({
    onChange,
    max,
    step,
    min,
    value,
}: {
    onChange: (val: string) => void
    max?: number
    min?: number
    step?: number
    value: number
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value)
    }
    return (
        <input
            type="range"
            max={max}
            min={min}
            step={step}
            onChange={handleChange}
            value={value}
            className={styles.slider}
        />
    )
}
